import { render, staticRenderFns } from "./selectList.vue?vue&type=template&id=c65bf044&scoped=true"
import script from "./selectList.vue?vue&type=script&lang=js"
export * from "./selectList.vue?vue&type=script&lang=js"
import style0 from "./selectList.vue?vue&type=style&index=0&id=c65bf044&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c65bf044",
  null
  
)

export default component.exports